// @flow
import React from 'react'
import MultiLine from 'components/Charts_MultiLine'
import { addDays, formatSwissDate } from 'components/Charts_Assets'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const isMobile = browserCheck.isMobile
const isSmallMobile = window.innerWidth <= 320

export class SmallMultiple extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }

  componentDidMount() {}

  render() {
    return <div className={this.props.data.length > 1 ? 'small-multiple' : 'single-chart small-multiple'}>
            {this.props.title !== undefined &&
              <h3>{this.props.title}</h3>
            }
            {this.props.subtitle !== undefined &&
              <h4>{this.props.subtitle}</h4>
            }
            <div className="flex-wrapper">
            {this.props.data &&
                this.props.data.map((m, i) => {

                    return (
                      <div className='column' key={'column-' + i}>
                        <div className='linechart' key={'linechart-' + i}>
                          <div className='chart-title'>
                            <span className='flag'>
                              <img
                                src={require('../../images/flags/1x1/' +
                                  m[1] +
                                  '.svg')}
                              />
                            </span>
                            <h5>{m[0]}</h5>
                          </div>
                          <MultiLine
                            data={[
                              m[3]
                                .filter((f, i) => i <= m[3].length - 1)
                                .map(m => {
                                  return { d: m.d, v: m.per, p: m.pop }
                                })
                                /*,
                                // second line
                              m[3]
                                .filter((f, i) => i < m[3].length - 1)
                                .map(m => {
                                  return { d: m.d, v: m.pop }
                                })*/
                            ]}
                            yDomain={[125, 0]}
                            xDomain={[
                              new Date(
                                new Date(m[3][0].d).getFullYear() - 15 + '-01-01'
                              ),
                              new Date(m[3][m[3].length - 1].d)
                            ]}
                            yTicks={{
                              lines: [0, 25, 50, 75, 100],
                              text: [25, 50, 75, 100],
                              unit: '%'
                            }}
                            height={140}
                            xTicks={{
                              text: !isSmallMobile
                                ? [
                                    '1950-01-01',
                                    '2000-01-01',  
                                    '2050-01-01',
                                    '2100-01-01'
                                  ]
                                : ['2050-01-01', '2100-01-01'],
                              lines: !isSmallMobile
                                ? [
                                    '1950-01-01',
                                    '2000-01-01',  
                                    '2050-01-01',
                                    '2100-01-01'
                                  ]
                                : ['2050-01-01', '2100-01-01']
                            }}
                            annotations={[[{
                                d: '2022-01-01',
                                v: 100,
                                p: 'middle',
                                t: i === 0 ? this.props.lang === 'fr' ? "aujourd'hui: " +m[2] : "heute: " +m[2] : m[2]
                            }]]}
                            className='chart'
                          />
                        </div>
                      </div>
                    )
                  
                })}
            </div>
            <div className='source' dangerouslySetInnerHTML={ { __html: this.props.source}} />
          </div>
  }
}
